import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryMerchant } from '../useMerchant';
import Section, { Caption as SectionCaption } from '../components/Section';
import Spacer from 'components/Spacer';
import Alert from 'components/Alert';
import withLoading from '../withLoading';
import RegionAndLocaleSets from '../RegionAndLocaleSets';
import MerchantForm from '../MerchantForm';
import { useQueryRegionAndLocalesSets } from '../useRegionAndLocaleSets';

type OldIntegrationFormProps = {
  formSectionRef: React.RefObject<HTMLDivElement>;
  listSectionRef: React.RefObject<HTMLDivElement>;
  disabled?: boolean;
};

const EnhancedMerchantForm = withLoading(MerchantForm);
const EnhancedRegionAndLocaleSets = withLoading(RegionAndLocaleSets);

const OldIntegrationForm = (props: OldIntegrationFormProps) => {
  const { formSectionRef, listSectionRef, disabled = false } = props;
  const { t } = useTranslation(['main', 'pageTitle']);
  const { isSuccess: isMerchantLoaded } = useQueryMerchant();
  const { isSuccess: isRegionAndLocalesSetsLoaded } =
    useQueryRegionAndLocalesSets();

  return (
    <>
      <Section title={t('Config GMC')} ref={formSectionRef}>
        <SectionCaption>{t('Config GMC Caption')}</SectionCaption>
        <EnhancedMerchantForm loading={!isMerchantLoaded} disabled={disabled} />
      </Section>
      <Section title={t('Config region & locale')} ref={listSectionRef}>
        <SectionCaption>{t('Config region & locale Caption')}</SectionCaption>
        <Spacer y=".5rem" />
        <Alert content={t('Config region & locale Alert')} />
        <Spacer y="1rem" />
        <EnhancedRegionAndLocaleSets
          loading={!isRegionAndLocalesSetsLoaded}
          disabled={disabled}
        />
      </Section>
    </>
  );
};

export default OldIntegrationForm;
